import {AccountCircle} from "@material-ui/icons";


export const EmployeePhotoFromBase64 = (props: { checkCondition?: true, base64img: string }) => {
    return props.checkCondition && props.base64img ? (<img
        src={props.base64img} alt="Avatar" style={{ width: "3em", height: "3em", borderRadius: "50%" }} />
    ) : (
        <AccountCircle style={{ width: "2em", height: "2em" }} />
    )
}